import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MPageContainerComponent } from './page-container.component';

@NgModule({
  imports: [CommonModule],
  declarations: [MPageContainerComponent],
  exports: [MPageContainerComponent]
})
export class MPageContainerModule {}
